
    export default {
        name: 'QuestionLabel',

        props: {
            question: {
                type: Object,
                default: () => { return {}; },
            },
        },

        data() {
            return {};
        },

        computed: {
            displayRule() {
                return true;
            },
        },

        methods: {},
    };
